<div class="label" [ngClass]="styleClasses()">
  <span class="fw-bold" wlCSCapture>{{ label() }}</span>
</div>
